/**
 * repeatable section with optional `conditionalShow` is visible only when
 * `formData[conditionalShow.groupKey]?.type` matches `conditionalShow.type`
 * (case-insensitive).
 */
export function isSchemaSectionShown(section, formData) {
  if (!section) return false;
  const cs = section.conditionalShow;
  if (!cs) return true;
  const selected = formData?.[cs.groupKey]?.type;
  if (selected == null || selected === "") return false;
  return (
    String(selected).toLowerCase() === String(cs.type).toLowerCase()
  );
}
